import React from 'react';

// Text-based logo tiles rendered in light neutral tones to match dark theme.
// This keeps quality crisp at any resolution and matches the site aesthetic.

const DEPLOYED = [
  { name: 'Adani', style: 'font-black tracking-tight text-2xl md:text-3xl' },
  { name: 'DP World', style: 'font-semibold tracking-widest text-xl md:text-2xl uppercase' },
  { name: 'Hind Terminals', style: 'font-light tracking-[0.35em] text-lg md:text-xl uppercase' },
  { name: 'JNPA', style: 'font-bold text-2xl md:text-3xl tracking-wide' },
  { name: 'CSL', style: 'font-serif italic text-2xl md:text-3xl' },
];

const BACKED = [
  { name: 'IIT', sub: 'Kharagpur', style: 'font-serif text-lg md:text-xl' },
  { name: 'IIM', sub: 'Calcutta', style: 'font-serif text-lg md:text-xl' },
  { name: 'IIM', sub: 'Bangalore', style: 'font-serif text-lg md:text-xl' },
  { name: 'nasscom', style: 'font-bold lowercase text-xl md:text-2xl tracking-tight' },
  { name: 'MeitY', sub: 'Startup Hub', style: 'font-semibold text-lg md:text-xl' },
  { name: 'NVIDIA', sub: 'Inception', style: 'font-black tracking-tight text-lg md:text-xl' },
  { name: 'Microsoft', sub: 'for Startups', style: 'font-semibold text-lg md:text-xl' },
  { name: '#startupindia', style: 'font-semibold text-lg md:text-xl tracking-tight' },
];

function LogoTile({ item }) {
  return (
    <div className="group flex flex-col items-center justify-center min-h-[64px] px-4 opacity-70 hover:opacity-100 transition-opacity">
      <span className={`text-slate-100 ${item.style}`}>{item.name}</span>
      {item.sub && (
        <span className="text-[10px] uppercase tracking-widest text-slate-400 mt-0.5">{item.sub}</span>
      )}
    </div>
  );
}

function Divider() {
  return (
    <div className="relative">
      <div className="h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" />
      <div className="absolute left-0 top-1/2 -translate-y-1/2 w-1 h-1 rounded-full bg-white/20" />
      <div className="absolute right-0 top-1/2 -translate-y-1/2 w-1 h-1 rounded-full bg-white/20" />
    </div>
  );
}

export default function DeployedSection() {
  return (
    <section className="relative border-t border-white/5 bg-[#0a0d12]">
      <div className="max-w-7xl mx-auto px-6 py-16">
        {/* Deployed at */}
        <div className="mb-12">
          <div className="text-[11px] font-mono uppercase tracking-[0.35em] text-slate-400 mb-8">Deployed at</div>
          <div className="grid grid-cols-2 md:grid-cols-5 gap-6 items-center">
            {DEPLOYED.map((d) => (
              <LogoTile key={d.name} item={d} />
            ))}
          </div>
        </div>

        <Divider />

        {/* Backed & recognised by */}
        <div className="mt-12">
          <div className="text-[11px] font-mono uppercase tracking-[0.35em] text-slate-400 mb-8">Backed &amp; recognised by</div>
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-8 gap-6 items-center">
            {BACKED.map((b, i) => (
              <LogoTile key={`${b.name}-${i}`} item={b} />
            ))}
          </div>
        </div>

        <div className="mt-12">
          <Divider />
        </div>

        <div className="mt-6 text-xs text-slate-500 font-mono tracking-wide">
          CII Best Industry AI Application 2025 <span className="text-slate-600 mx-2">·</span> Patented Technology
        </div>
      </div>
    </section>
  );
}
